/**
 * Hreflang Tag Generator
 */

import languageConfig from '../config/languageConfig';
import { DEFAULT_SITE_URL } from '../config/siteConfig';

export const generateHreflangTags = (pagePath, options = {}) => {
  const {
    baseUrl = typeof window !== 'undefined' ? window.location.origin : DEFAULT_SITE_URL,
    languages = languageConfig.getLanguageCodes(),
  } = options;

  const tags = [];

  languages.forEach((lang) => {
    const langObj = languageConfig.getLanguage(lang);
    if (!langObj) return;
    const urlCode = languageConfig.getUrlCode(lang);
    const url =
      lang === languageConfig.defaultLanguage
        ? `${baseUrl}${pagePath}`
        : `${baseUrl}/${urlCode}${pagePath}`;
    tags.push({ rel: 'alternate', hreflang: langObj.locale || lang, href: url });
  });

  tags.push({ rel: 'alternate', hreflang: 'x-default', href: `${baseUrl}${pagePath}` });

  return tags;
};

export const getLanguageFromUrl = (pathname = null) => {
  if (typeof window === 'undefined' && !pathname) return languageConfig.defaultLanguage;
  const path = pathname || window.location.pathname;
  const segments = path.split('/').filter(Boolean);

  if (segments.length === 0) {
    const stored = localStorage.getItem('preferredLanguage');
    const supportedCodes = languageConfig.getLanguageCodes();
    if (stored && supportedCodes.includes(stored)) return stored;
    return languageConfig.defaultLanguage;
  }

  const firstSegment = segments[0];
  const urlCodes = languageConfig.getUrlCodes();

  if (urlCodes.includes(firstSegment)) {
    return languageConfig.getTranslationCode(firstSegment);
  }

  const stored = localStorage.getItem('preferredLanguage');
  const supportedCodes = languageConfig.getLanguageCodes();
  if (stored && supportedCodes.includes(stored)) return stored;

  return languageConfig.defaultLanguage;
};

export const generateLanguageUrl = (path, language) => {
  if (!path) return '';
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : DEFAULT_SITE_URL;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const urlCode = languageConfig.getUrlCode(language);
  if (language === languageConfig.defaultLanguage) return `${baseUrl}${cleanPath}`;
  return `${baseUrl}/${urlCode}${cleanPath}`;
};
